<div class="dialog-header">
    <h2 mat-dialog-title>Reorder Children</h2>
    <button mat-icon-button mat-dialog-close class="close-button" aria-label="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    <!-- Error State -->
    @if (errorMessage) {
        <div class="error-container">
            <mat-icon color="warn">error</mat-icon>
            <span>{{ errorMessage }}</span>
        </div>
    }

    <!-- Parent Info & Children List -->
    @if (parentPart && !errorMessage) {
        <div class="parent-header">
            <span class="parent-name">{{ parentPart.name }}</span>
            <span class="child-count">{{ children.length }} children</span>
        </div>

        <p class="instructions">
            Drag and drop to reorder, or use the arrow buttons.
        </p>

        <!-- Children List -->
        <div cdkDropList 
             class="children-list" 
             (cdkDropListDropped)="onDrop($event)">
            @for (child of children; track child.partKey; let i = $index) {
                <div class="child-item" 
                     cdkDrag
                     [ngStyle]="{ 
                         'background-color': getChildColor(child),
                         'color': getTextColor(child)
                     }">
                    
                    <!-- Drag Handle -->
                    <div class="drag-handle" cdkDragHandle>
                        <mat-icon>drag_indicator</mat-icon>
                    </div>

                    <!-- Position Number -->
                    <span class="position-number">{{ i + 1 }}</span>

                    <!-- Child Info -->
                    <div class="child-info">
                        <span class="child-name">{{ child.name }}</span>
                        <span class="child-type">{{ child.partType }}</span>
                    </div>

                    <!-- Move Buttons -->
                    <div class="move-buttons">
                        <button mat-icon-button 
                                [disabled]="i === 0"
                                (click)="moveUp(i)"
                                title="Move up">
                            <mat-icon>keyboard_arrow_up</mat-icon>
                        </button>
                        <button mat-icon-button 
                                [disabled]="i === children.length - 1"
                                (click)="moveDown(i)"
                                title="Move down">
                            <mat-icon>keyboard_arrow_down</mat-icon>
                        </button>
                    </div>

                    <!-- Drag Placeholder -->
                    <div class="drag-placeholder" *cdkDragPlaceholder></div>
                </div>
            }
        </div>

        <!-- Empty State -->
        @if (children.length === 0) {
            <div class="empty-state">
                <mat-icon>info</mat-icon>
                <span>No children to reorder</span>
            </div>
        }
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-stroked-button 
            [disabled]="!hasChanges"
            (click)="resetOrder()">
        <mat-icon>undo</mat-icon>
        Reset
    </button>
    <button mat-flat-button 
            color="primary" 
            [disabled]="!hasChanges || isSaving"
            (click)="saveOrder()">
        @if (isSaving) {
            <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
        } @else {
            <mat-icon>save</mat-icon>
        }
        Save Order
    </button>
</mat-dialog-actions>
